import { Modal, Stack, Text } from "@mantine/core"
import { Button } from "@tfg/ui"

type AnonymizeUserModalProps = {
  close: () => void
  handleAnonymizeUser: () => void
  opened: boolean
  userName: string
}

export const AnonymizeUserModal = ({
  close,
  handleAnonymizeUser,
  opened,
  userName,
}: AnonymizeUserModalProps) => {
  const validateAnonymizeUser = () => {
    handleAnonymizeUser()
    close()
  }

  return (
    <Modal opened={opened} onClose={close} title="Anonymize user" centered>
      <Stack>
        <Text>Are you sure you want to anonymize {userName}?</Text>
        <Button
          variant="primary"
          style={{ alignSelf: "flex-end" }}
          onClick={validateAnonymizeUser}
        >
          Anonymize
        </Button>
      </Stack>
    </Modal>
  )
}
